import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    showTryArea: boolean = false;
    currentLang: string = 'tr';
    isLanguageDropdownOpen: boolean = false;

    constructor(
        public router: Router,
        public languageService: LanguageService,
        private translateService: TranslateService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void {
        this.currentLang = this.languageService.getDefaultLanguage();
        this.checkRoute();
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.checkRoute();
            this.cdr.markForCheck();
        });

        // Listen to language changes
        this.languageService.currentLanguage$.subscribe(lang => {
            this.currentLang = lang;
            this.cdr.markForCheck();
        });
    }

    checkRoute(): void {
        const url = this.router.url.toLowerCase();

        // Anasayfa kontrolü (/ veya /en)
        const isHomePage = url === '/' || url === '/en';

        // Entegrasyon sayfaları kontrolü
        const isIntegrationPage = url.includes('entegrasyon') ||
            url.includes('integration') ||
            url.includes('kargo') ||
            url.includes('cargo');

        this.showTryArea = isHomePage || isIntegrationPage;
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    toggleLanguageDropdown() {
        this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
        this.cdr.markForCheck();
    }

    changeLanguage(lang: string) {
        this.languageService.changeLanguage(lang);
        this.currentLang = lang;
        this.isLanguageDropdownOpen = false;
        this.cdr.markForCheck();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (!target.closest('.language-dropdown')) {
            this.isLanguageDropdownOpen = false;
            this.cdr.markForCheck();
        }
    }

    copyrightText: Text[] = [
        {
            text: 'dotCREA © 2024 All Rights Reserved.',
            linkText: 'dotCREA',
            link: 'https://www.dotcrea.com/'
        }
    ]

}
class Text {
    text: string;
    linkText: string;
    link: string;
}
